import axios from 'axios';
import moment from 'moment-timezone';

export const AVAILABILITY_LOADING = 'AVAILABILITY_LOADING';
export const AVAILABILITY_SUCCESS = 'AVAILABILITY_SUCCESS';
export const AVAILABILITY_ERROR = 'AVAILABILITY_ERROR';

export function fetchAvailabilityByDateAndDuration(serviceId, start, end, durationInMinutes = 30) {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch({ type: AVAILABILITY_LOADING });

    // Don't bother making the API call if the end time is <= start time
    if (end <= start) {
      dispatch({
        type: AVAILABILITY_SUCCESS,
        payload: {
          data: {
            data: []
          }
        },
      });
      return;
    }

    const minTime = start.utc().format('YYYY-MM-DD HH:mm:ss');
    const maxTime = end.utc().format('YYYY-MM-DD HH:mm:ss');
    const { token } = state.user;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    axios
      .get(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/availability?minTime=${minTime}&maxTime=${maxTime}` +
        `&duration=${durationInMinutes}&serviceId=${serviceId}&tz=${moment.tz.guess()}`,
        { headers }
      )
      .then(response => {
        dispatch({
          type: AVAILABILITY_SUCCESS,
          payload: response,
        });
      })
      .catch(result => {
        dispatch({
          type: AVAILABILITY_ERROR,
          payload: result,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/availabilityActions.js